import { SVG, SVGProps } from './svg'

export function IconIdeaSave(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M12 4a6 6 0 016 5 5.5 5.5 0 01-.5 11H6a5 5 0 010-10 6 6 0 016-6zm.4 12.9l3.5-3.6c.2-.2.2-.5 0-.7l-.2-.2-.4-.1H14V8.5c0-.3-.2-.5-.5-.5h-3c-.3 0-.5.2-.5.5v3.8H8.7l-.4.1-.2.2c-.2.2-.2.5 0 .7l3.5 3.6c.2.1.6.1.8 0z" />
    </SVG>
  )
}
